import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "hideBorder"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { H4 } from '@atlassian/mpac-primitives';
import * as React from 'react';
import { HeadingWrapper } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const Heading = props => {
  const {
      children,
      hideBorder = false
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(HeadingWrapper, {
    $bottomBorder: !hideBorder,
    children: /*#__PURE__*/_jsx(H4, _objectSpread(_objectSpread({
      as: "h3"
    }, otherProps), {}, {
      children: children
    }))
  });
};